import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event-package';
import { ChartService } from '../../services/chart.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-endpoint-info',
  templateUrl: './endpoint-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./endpoint-info.component.scss']
})
export class EndpointInfoComponent implements OnInit {
  @Input() chart;
  @Output() openEndpointDetails = new EventEmitter<boolean>();
  colors = this.commonService.colors;

  constructor(
    private chartService: ChartService, private commonService: CommonService) {
  }

  ngOnInit(): void {
  }


  onResized(event: ResizedEvent, chart, chartDivId: string) {
    this.chartService.onResized(chart, event, chartDivId);
  }

  endpointAllDetail() {
    this.openEndpointDetails.emit(true);
  }
}
